/*
 * @Author: yyq
 * @Date: 2023-03-21 10:40:08
 * @LastEditors: yyq
 * @LastEditTime: 2024-04-29 10:37:45
 * @FilePath: \WconNet.iot.Webview\src\main.js
 * @Description:
 *
 * Copyright (c) 2024 by wcon/yyq, All Rights Reserved.
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAMap from "@vuemap/vue-amap";
import "@vuemap/vue-amap/dist/style.css";

Vue.config.productionTip = false;
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // plugins:["AMap.MoveAnimation"],
  // plugins: ["AMap.ToolBar"],
  key: "e5861899e51a0aa9ff8f2313e77f788a",
  securityJsCode: "0123d305ee8f9ba0e342d7180ddeac90",
});
// import VueAmapThree from '@vuemap/vue-amap/dist/three'
// Vue.use(VueAmapThree);
//import Vconsole from 'vconsole'
//import axios from "./config/axoisConfig.js";

// var vConsole = new window.VConsole();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
